import "../common/pollyfills";
import GetStreamAPI from "../common/get-stream-api";

const {
  initSentry,
  htmlSubstring,
  showExpandedState,
  handleIsMobileDevice,
} = require("../common/helper");

const config = require("../../config");
export class AnnouncementComponent {
  constructor() {
    initSentry();
    this.options = {};
    this.annoucementJson = {};
  }

  initAnnoucement(annoucementContainerId) {
    this.generateAnnoucementsJson()
      .then((res) => {
        this.options.annoucementContainerId = annoucementContainerId;
        this.annoucementJson = res;
        this.generateAllAnnouncementsUI();
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  }

  // exposing a function to fetch announcments in case required by consumer app
  async getAnnouncements() {
    let res = await this.generateAnnoucementsJson();
    return res;
  }

  removeAnnoucement() {
    // not removing container element as it may be used in apps to load notifications again.
    const element = document.getElementById("annoucements-section");
    if (element) {
      element.remove();
    }
  }

  // expandIndex is the announcement index to be expanded.
  generateAllAnnouncementsUI(expandIndex = undefined) {
    let html = this.generateAnnoucementsCollapsible(
      this.annoucementJson,
      expandIndex
    );
    if (html) {
      this.renderAnnoucements(this.options.annoucementContainerId, html);
    }
  }

  renderAnnoucements(annoucementsContainerId, html) {
    let element = document.getElementById(annoucementsContainerId);
    element.innerHTML = html;
    // add event listeners for toggle functionality(See more , See less)
    this.addToggleFunctionality();
    // add event listeners for close functionality(only for low and medium priority announcements)
    this.addCloseFunctionality();
  }

  getIconSVG(icon) {
    switch (icon) {
      case "medium":
        return `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.1856 20.3007L4.80662 20.4059L11.8906 6.02656L19.1856 20.3007Z" stroke="#323232"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0294 14.9189L13.0293 14.9042L12.9999 10.9043L11 10.919L11.0294 14.9189Z" fill="#323232"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0514 17.9198L13.0513 17.9051L13.0366 15.9042L11.0367 15.9188L11.0514 17.9198Z" fill="#323232"/>
                    </svg>
                `;

      case "high":
        return `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.029 4.91179L4.1466 20.9701L20.1462 20.8526L12.029 4.91179ZM11.1024 14.9189L13.1023 14.9042L13.073 10.9043L11.073 10.919L11.1024 14.9189ZM11.1244 17.9198L13.1244 17.9051L13.1097 15.9042L11.1097 15.9188L11.1244 17.9198Z" fill="#323232"/>
                    </svg>
                `;

      case "low":
        return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 19.9487C16.4183 19.9487 20 16.367 20 11.9487C20 7.53045 16.4183 3.94873 12 3.94873C7.58172 3.94873 4 7.53045 4 11.9487C4 16.367 7.58172 19.9487 12 19.9487ZM12.999 15.9487H11V11.9487H12.999V15.9487ZM18 11.9487C18 15.2624 15.3137 17.9487 12 17.9487C8.68629 17.9487 6 15.2624 6 11.9487C6 8.63502 8.68629 5.94873 12 5.94873C15.3137 5.94873 18 8.63502 18 11.9487ZM12.999 9.94873H11V7.94873H12.999V9.94873Z" fill="#323232"/>
                    </svg>
                `;

      case "cross":
        return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5863L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5863 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072Z"
                          fill="#323232"
                        />
                        <mask
                          id="mask0_311_6164"
                          style="mask-type:luminance"
                          maskUnits="userSpaceOnUse"
                          x="6"
                          y="6"
                          width="13"
                          height="13"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5863L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5863 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072Z"
                            fill="white"
                          />
                        </mask>
                        <g mask="url(#mask0_311_6164)"></g>
                    </svg>`;
      default:
        return "";
    }
  }
  generateAnnoucementsCollapsible(annoucementJson, expandIndex = undefined) {
    let annoucementBody = "";
    annoucementJson.results.forEach((announcement, index) => {
      let annoucementJSON = JSON.parse(JSON.stringify(announcement));
      //get the service_announcement object from the session storage and check if the announcementid is present in closedAnnouncements array then do not render that announcement
      let closedAnnouncements =
          JSON.parse(localStorage.getItem(
            config.appSetting.localStorage.announcement.key
        )) || [];
      if (closedAnnouncements.includes(annoucementJSON.id)) {
        return;
      }
      announcement = announcement["service_announcement"];
      let desc;
      if (handleIsMobileDevice()) {
        desc = htmlSubstring(announcement["message"], 92, true);
      } else {
        desc = htmlSubstring(announcement["message"], 174, true);
      }

      const isTextExpanded = expandIndex == index;
      let trimClass = "";

      if (isTextExpanded) {
        desc = showExpandedState(announcement["message"]);
      } else {
        trimClass = "trim-message-text";
      }

      annoucementBody += `<div class="annoucements-card-body p-2 flex-row" index=${index} id="${annoucementJSON.id}">
                <span class="d-flex align-items-start icon-wrapper mr-2 me-2">
                    ${this.getIconSVG(announcement.priority)}
                </span>
                <div class="${trimClass} align-items-center annoucement-desc" id="annoucement-desc">${desc}</div>
                ${
                  announcement.priority === "high"
                    ? ""
                    : `<span class="announcement-cross-wrapper"><button  class="announcement-cross-icon">${this.getIconSVG(
                        "cross"
                      )}</button></span>`
                }
            </div>`;
    });
    let html =
      `
            <div id= "annoucements-section" class="card annoucements-section display-block display-none">
                ` +
      annoucementBody +
      `</div></div>`;
    return html;
  }

  async generateAnnoucementsJson() {
    const annoucementJSON = await GetStreamAPI.getServiceAnnoucement();
    return annoucementJSON.feedData;
  }

  addCloseFunctionality() {
    //close the announcement and remove the announcement from the dom and store in session storage
    const closeElement = document.querySelectorAll(".announcement-cross-icon");

    closeElement.forEach((element) => {
      element.addEventListener("click", function (event) {
        const announcementElement = event.target.closest(
          ".annoucements-card-body"
        );
        const announcementId = announcementElement.getAttribute("id");
        //remove the announcement from the dom
        announcementElement.remove();
        let closedAnnouncements =
            JSON.parse(localStorage.getItem(
              config.appSetting.localStorage.announcement.key
            )) || [];
            closedAnnouncements.push(announcementId);
        let key = config.appSetting.localStorage.announcement.key;
        localStorage.setItem(key, JSON.stringify(closedAnnouncements));
        //if the closed announcement  has index 0 then remove the border top from the next announcement[NEMO-18718] Issue: https://github.com/comproQA/Support-Admin/issues/26
        if (announcementElement.getAttribute("index") == 0) {
          let nextAnnouncement = document.querySelector(
            `.annoucements-card-body[index="${
              parseInt(announcementElement.getAttribute("index")) + 1
            }"]`
          );
          if (nextAnnouncement) {
            //add style to remove border top
            nextAnnouncement.style.borderTop = "none";
          }
        }
        //if the closed announcement is the last announcement then add class margin-small to previous announcement([NEMO-18718]) https://github.com/comproQA/Support-Admin/issues/25
        let previousAnnouncement = document.querySelector(
          `.annoucements-card-body[index="${
            parseInt(announcementElement.getAttribute("index")) - 1
          }"]`
        );
        if (previousAnnouncement) {
          previousAnnouncement.classList.add("margin-small");
        }
      });
    });
  }

  addToggleFunctionality() {
    let announcementToggleElems = document.querySelectorAll(
      ".announcement-toggle"
    );
    let self = this;
    if (announcementToggleElems) {
      announcementToggleElems.forEach((announcementToggleElem) => {
        announcementToggleElem.addEventListener("click", function (event) {
          const announcementDesc =
            announcementToggleElem.closest(".annoucement-desc");
          const isTextTrimmed =
            announcementDesc.classList.contains("trim-message-text");
          let index;
          if (isTextTrimmed) {
            index = parseInt(
              announcementDesc
                .closest(".annoucements-card-body")
                .getAttribute("index")
            );
          }
          self.generateAllAnnouncementsUI(index);
        });
      });

      let anchors = document.querySelectorAll(".annoucements-card-body a");
      const nonAnnouncementToggleAnchors = Array.from(anchors).filter(
        (anchor) => !anchor.classList.contains("announcement-toggle")
      );

      if (nonAnnouncementToggleAnchors) {
        nonAnnouncementToggleAnchors.forEach((element) => {
          element.addEventListener("click", function (event) {
            // to stop expanding/collapsing of announcement on clicking a link
            event.stopPropagation();
            event.stopImmediatePropagation();
          });
        });
      }
    }
  }
}

// Load Event Fired
(function fireEventOnNotificationScriptLoaded() {
    let evt = new CustomEvent('cambridgeOne.announcementComponentLoaded');
    console.log("Announcements File Loaded")
    window.dispatchEvent(evt);
})();